import { Component, OnInit } from '@angular/core';
import moment from 'moment/moment';
import { concatMap, map, Observable, of, shareReplay, tap } from 'rxjs';
import { HttpService } from 'src/app/services/http/http.service';
import { pageData } from '../report-routing.module';
import { ResponseSalesAggregate } from 'src/app/models/ResponseSalesAggregate';
import { ApiUrl } from 'src/app/models/ApiUrl';

@Component({
    selector: 'app-chart-report',
    templateUrl: './chart-report.component.html',
    styleUrls: ['./chart-report.component.scss'],
    standalone: false
})
export class ChartReportComponent implements OnInit {
  pageData = pageData;
  loader$: Observable<{ From: Date | null, To: Date | null }>;
  private readonly loaderEndpoint = 'Report/GetLoader';

  data$: Observable<{pieChartData: any, pieChartConfig: any}>;
  private readonly dataEndpoint = ApiUrl.SALES_REPORT_CHART;

  title$: Observable<string> = of('');

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.loader$ = this.http.post<{ Filter: { Date: Date | null } }>(`/API/${this.loaderEndpoint}`)
      .pipe(
        map(res => {
          return {
            From: res.Filter.Date,
            To: res.Filter.Date
          }
        }),
        shareReplay()
      )

    this.data$ = this.loader$.pipe(
      concatMap(loader => this.fetchData$(loader)),
    )
  }
  onFilterSearch(loader: { From: Date | null, To: Date | null }) {
    this.data$ = this.fetchData$(loader)
  }
  fetchData$(loader: { From: Date | null, To: Date | null }) {
    return this.http.post<ResponseSalesAggregate>(this.dataEndpoint, loader)
    .pipe(
      map(data => {
        let pieChartData = data.Data.map(d => {
          return {
            name: `${d.Subdomain}`,
            y: d.Profit
          }
        })
        let pieChartConfig = {
          title: '',
          dataLabels: true,
          labelTooltips: 'Sales',
          height: 400,
          legend: {}
        }
        return {
          pieChartData: pieChartData,
          pieChartConfig: pieChartConfig
        }
      }),
      tap(() => {
          const formattedFrom = moment(loader.From).format('D MMM yyyy')
          const formattedTo = moment(loader.To).format('D MMM yyyy')
          this.title$ = of(`Sales Transaction [${formattedFrom != formattedTo ?
            formattedFrom + ' - ' + formattedTo
            : formattedFrom}]`)
      })
    )
  }
}
